import { render, staticRenderFns } from "./appealDialog.vue?vue&type=template&id=5508b0b6&"
import script from "./appealDialog.vue?vue&type=script&lang=js&"
export * from "./appealDialog.vue?vue&type=script&lang=js&"
import style0 from "./appealDialog.vue?vue&type=style&index=0&id=5508b0b6&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports